import PropTypes from 'prop-types';
import React from 'react';
import Store from '@app/store';
import Analytics from '@module/analytics';
import Translations from '@module/i18n/dictionary';
import Scrollable from '@component/scrollable';
import Actions from '@app/action';

import PopTip from '@component/info/poptip';
import Icon from '@component/icon';

import { OSLO_GRAY } from '@constant/colors';

export default class LanguagePicker extends React.Component {
  static propTypes = {
    popupOptions: PropTypes.object,
    currentLanguage: PropTypes.string,
  };

  async changeLanguage(language) {
    await Store.dispatch(Actions.User.updateUserLanguage(language));

    // Update html[lang] if possible
    const docRoot = document.documentElement;
    if (docRoot && docRoot.lang) {
      docRoot.setAttribute('lang', language);
    }

    // Update the session store and close poptip
    Store.dispatch(Actions.Session.setLanguage(language));

    Analytics.trackStructEvent({
      category: 'language',
      action: 'click_language_drop_down',
      label: language,
    });
  }

  render() {
    const options = [];
    for (const locale in Translations.locales) {
      options.push({
        value: locale,
        label: Translations.locales[locale][0], // 0 = Native language, 1 = English
      });
    }

    const currentLabel = options.filter(
      (option) => option.value === this.props.currentLanguage
    );

    let items = (
      <ul className="languagepicker__list">
        {options.map((option, index) => {
          const className =
            this.props.currentLanguage === option.value
              ? 'tooltip__active-item'
              : null;
          return (
            <li
              key={'language_changer' + index}
              onClick={() => this.changeLanguage(option.value)}
              className={className}
            >
              {option.label}
            </li>
          );
        })}
      </ul>
    );

    items = (
      <Scrollable ref={(node) => (this._scrollable = node)}>{items}</Scrollable>
    );

    return (
      <PopTip
        className="languagepicker"
        trigger="click"
        offset={10}
        content={items}
        onClick={this.hide}
        handleChange={() =>
          this._scrollable && this._scrollable.shouldShowOverflow()
        }
        unique={true}
        {...this.props.popupOptions}
      >
        <span className="languagepicker__current">
          {currentLabel[0].label}
          <Icon
            color={OSLO_GRAY}
            className="languagepicker__arrow"
            type="Arrow"
            orientation="bottom"
          />
        </span>
      </PopTip>
    );
  }
}
